var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"Home"}},[_c('Carousel'),_c('CoreStory'),_c('Parallax'),_c('OriginStory'),_c('ArtStory'),_c('Gallery'),_c('News'),_c('Position')],1)}
var staticRenderFns = []

export { render, staticRenderFns }